module.exports = __webpack_public_path__ + "img/page1.c3a17525.png";